import { makeStyles } from 'tss-react/mui';
import { spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    productGallery: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
    },
    galleryTitle: {
        height: '36px',
        width: '100%',
        marginBottom: spacing.small,
        [theme.breakpoints.up('sm')]: {
            width: '80%',
        },
        [theme.breakpoints.up('xl')]: {
            marginBottom: spacing.medium,
        },
    },
    galleryMessage: {
        height: '85px',
        width: '100%',
        marginBottom: spacing.large,
    },
    desktopContainer: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'block',
        },
    },
    mobileContainer: {
        display: 'block',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    skeletonCarouselContainer: {
        margin: '0 auto',
        width: '100%',
    },
    list: {
        display: 'grid',
        gridTemplateColumns: 'repeat(1, 1fr)',
        [theme.breakpoints.up('md')]: {
            gridTemplateColumns: 'repeat(3, 1fr)',
            gridGap: spacing.small,
        },
    },
    linkContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        marginBottom: spacing.large,
        marginTop: spacing.large,
    },
    link: {
        height: '48px',
        width: '200px',
    },
    skeletonCarouselNavContainer: {
        marginTop: spacing.small,
    },
}));
export default useStyles;
